import 'stylesheets/collections/collection-item-panel';
import AddToFoldersButton from 'js/add_to_folder/button'
import lazyAssetsObserver from 'js/lib/lazy_assets';
import { bindPlayCollection } from './play_collection'

require('shared_collections/item_viewer_renderer')
require('problem_modal_events')
import posthog from 'posthog-js';
import { PH_EVENTS } from 'js/posthog_analytics'
import HowdyBoxStatic from 'js/searches/howdy_box/howdy_box_static';

SharedCollections  = LP.module('SharedCollections')
VideoItemsManager  = SharedCollections.VideoItemsManager
AudioItemsManager  = SharedCollections.AudioItemsManager
ItemViewerRenderer = SharedCollections.ItemViewerRenderer
CommonCoreInfo     = LP.module 'CommonCoreInfo'
SharedCollections.bindPlayCollection = bindPlayCollection

itemSlideMargin = 30
itemSlideWidth  = 180

SharedCollections.show = ->
  lazyAssetsObserver.observe()
  $('[data-toggle="popover"]').popover()
  LP.module('Popovers').init()
  LP.module('Dropdowns').toggleOnRemoteLinks()
  LP.module('ProblemModalEvents').init()
  LP.module("Analytics").trackVirtualPageSuccess()
  @initEducatorRatings()
  @bindSaveErrorsHandler()
  @initAddToFoldersButton($('.add-to-folders-btn:visible')[0])
  @bindPlayButton()
  bindPlayCollection()

  `import(/* webpackChunkName: 'bxslider' */ 'js/vendor/bxslider')`.then(() ->
    bindItemSlider()
    bindItemRRPSlider()
    bindNotesTooltip()
    bindItemCardsClicks()
    iePreventItemDrag()
  )

  if LP.config.ai_teachers_tools_howdy_box_enabled
    howdyBoxContainer = document.getElementById('howdy-box');
    ReactDOM.createRoot(howdyBoxContainer).render(
      React.createElement(HowdyBoxStatic)
    );

  bindSeeFullReviews()
  bindCloseRRP()
  # IN MODAL - we need to trigger this after the resources.css loads.
  setTimeout (->
    LP.bindRRPToggle()
  ), 100

  SharedCollections.itemSliders = {}

  LP.module('Share').bindRRPShareButtons()
  if LP.config.static_resource_page
    LP.module('LinkOpener').bindOpenResourceInCollections()

  # Tablets trigger both AJAX & HTML calls to href.
  $('a[data-remote=true]').on 'click', (e) ->
    e.preventDefault()

  CommonCoreInfo.popovers('.js-cc-popover a.btn-standard')

  # iPAD
  window.onunload = (e) ->
    # Fixed page refreshes when the user has a RRP open and the page is
    # scrolled into view. The page is focused to top after refresh.
    window.scrollTo(0, 0)

  # Desktops. Chrome.
  window.onbeforeunload = (e) ->
    # Fixed page refreshes when the user has a RRP open and the page is
    # scrolled into view. The page is focused to top after refresh.
    window.scrollTo(0, 0)

bindSeeFullReviews = ->
  $('.see-full-reviews-link').on 'click', (e) ->
    # When the user is not on the first slide we need to take him back.
    itemSlider.goToSlide(0)
    $('.item-rrp-link[data-i=0]').click()

sliderFooterContent = ->
  $('.expanded-item-rrps .content')


bindItemCardsClicks = ->
  $('.item-rrp-link').on 'click touchstart', (e) ->
    e.preventDefault()

    if isItemViewerOpen()
      rrpSlider.goToSlide($(@).data().i)
    else
      $('.panel-rrp').show()
      rrpSlider.reloadSlider()
      if $(@).data().i == 0
        # Special case for the first slide. Because the slides start from 0
        # goToSlide(0) doesn't trigger onSlideBefore.
        selectItemWithOpenRRP(0)
        ItemViewerRenderer.render($('.rrp-content[data-i=0]'), 0)
      else
        rrpSlider.goToSlide($(@).data().i)

    sliderFooterContent().hide()
    $('.popover-title .close').click()
    scrollItemsIntoView()

unselectItemPanels = ->
  $('.item-rrp-link .collection-item-panel').removeClass('selected')


bindCloseRRP = ->
  $('.close-item-rrp-view').on 'click', (e) ->
    closePopovers() # CCSS/NGSS popovers are sticky
    index = $('.rrp-content[aria-hidden=false]').data()['i']
    VideoItemsManager.stopVideoIfPlaying(getSlide(index))
    AudioItemsManager.stopAudioIfPlaying(getSlide(index))
    deactivateSlider(index)
    $('.panel-rrp').fadeOut 'fast', ->
      sliderFooterContent().show()
      unselectItemPanels()

    scrollToTop()

bindNotesTooltip = ->
  $('.note-icon').tooltip()

showOutOfNumber = ->
  { itemSlider, itemsPerSlide } = window
  current = (itemSlider.getCurrentSlide() + 1) * itemsPerSlide
  total = itemSlider.getSlideCount()
  current = total if total < current
  $('.showing-out-of').html("Showing #{current} of #{total} items")

bindItemSlider = ->
  window.itemSlider = $('.item-list').bxSlider
    autoStart: false
    pager: false
    slideWidth: itemSlideWidth
    minSlides: 1
    maxSlides: 4
    slideMargin: itemSlideMargin
    infiniteLoop: false
    hideControlOnEnd: true
    touchEnabled: !LP.isDesktop() # cannot click on items on latest Chrome & jQuery
    nextSelector: '#item-slider-next'
    prevSelector: '#item-slider-prev'
    nextText: '<i class="fa-regular fa-angle-right"></i>'
    prevText: '<i class="fa-regular fa-angle-left"></i>'
    onSliderLoad: ->
      setItemsPerSlideCount()
      $('.item-list').css(visibility: 'visible')
      $('.bx-prev, .bx-next').css(visibility: 'visible')
      $('.slider-footer').css(visibility: 'visible')
      $('.items-container .bx-viewport').css('overflow', 'visible')
      # To make sure that the player is loaded
      setTimeout (->
        showOutOfNumber()
      ), 0
    onSlideBefore: ->
      $('.panel-rrp').removeClass('selected-arrow')
      showOutOfNumber()
    onSlideAfter: ($slideElement, oldIndex, newIndex) ->
      updateArrowPosition() if isItemViewerOpen()
      showOutOfNumber()
    onSliderResize: (currentIndex) ->
      setItemsPerSlideCount()
      if isItemViewerOpen()
        scrollItemsIntoView()
        updateArrowPosition()
      showOutOfNumber()

  $('.items-container .bx-viewport').bind 'touchmove', ->
    $('.panel-rrp').removeClass('selected-arrow')

  $('.items-container .bx-viewport').bind 'touchend', ->
    # Swipe and item and release on its original position
    # should show the arrow again.
    $('.panel-rrp').addClass('selected-arrow')

bindItemRRPSlider = ->
  window.rrpSlider = $('.rrp-list').bxSlider
    autoStart: false
    pager: false
    infiniteLoop: false
    hideControlOnEnd: true
    nextSelector: '#slider-next'
    prevSelector: '#slider-prev'
    nextText: '<i class="fa-regular fa-angle-right"></i>'
    prevText: '<i class="fa-regular fa-angle-left"></i>'
    touchEnabled: !LP.isDesktop() # cannot click on items on latest Chrome & jQuery
    onSlideBefore: ($slideElement, oldIndex, newIndex) ->
      VideoItemsManager.stopVideoIfPlaying(getSlide(oldIndex))
      AudioItemsManager.stopAudioIfPlaying(getSlide(oldIndex))
      deactivateSlider(oldIndex)
      closePopovers() # CCSS/NGSS popovers are sticky
      selectItemWithOpenRRP(newIndex)

      ItemViewerRenderer.render($slideElement, newIndex)

    onSliderResize: (currentIndex) ->
      SharedCollections.adjustPanelHeight(currentIndex) if isItemViewerOpen()

getSlide = (slideIndex) ->
  $(".rrp-content[data-i=#{slideIndex}]")

deactivateSlider = (index) ->
  if slider = SharedCollections.itemSliders[index]
    slider.deactivate()

selectItemWithOpenRRP = (index) ->
  element = $(".item-rrp-link[data-i=#{index}] .collection-item-panel")
  unless element.hasClass('selected')
    $('.dynamic-stylesheets').html('') # clear old stylesheets
    unselectItemPanels()
    element.addClass('selected')

  updateSlideCounter(index)
  newSlideNumber = getSlideNumberForIndex(index)
  if newSlideNumber != window.itemSlider.getCurrentSlide()
    window.itemSlider.goToSlide(newSlideNumber)
  else
    updateArrowPosition()

updateArrowPosition = ->
  selectedPanel = $('.panel-items .collection-item-panel.selected')
  if selectedPanel[0]
    main_panel_width       = $('.panel-items').outerWidth()
    main_panel_offset      = $('.panel-items').offset().left
    # that 5 is the difference to set the arrow point to the middle of the selected slide.
    selected_item_position = selectedPanel.offset().left + selectedPanel.outerWidth()/2 + 5
    percentage             = ((selected_item_position - main_panel_offset) * 100) / main_panel_width

    $('.panel-rrp').addClass('selected-arrow')
    $('.dynamic-stylesheets').html('') # clear old stylesheets

    if percentage > 0 && percentage < 100
      $("<style>
          .panel-rrp:before{left:#{percentage}%; bottom:100%; border:solid transparent; }
          .panel-rrp:after{left:#{percentage}%; bottom:100%; border:solid transparent; }
        </style>"
      ).appendTo('.dynamic-stylesheets')

closePopovers = ->
  $('.popover-title .close').click()
  $('button[data-dismiss="popover"]').click()

isItemViewerOpen = ->
  $('.panel-rrp').is(':visible')

setItemsPerSlideCount = ->
  window.itemsPerSlide = Math.round($('.panel-items .bx-viewport').width() / (itemSlideWidth + itemSlideMargin))

getSlideNumberForIndex = (index) ->
  Math.floor(index / window.itemsPerSlide)

# When the user selects an items to see its RRP we focus the item slider (scroll it to top)
scrollItemsIntoView = ->
  if $('#resource-modal .shared_collection')[0]
    aboveItemSliderAreaHeight = $('.rrp-top.panel-heading').outerHeight() + $('.rrp-details.panel-body').outerHeight() + 10
    $('.shared_collection').css('height': window.height + aboveItemSliderAreaHeight)
  $('.panel-items')[0].scrollIntoView()

# When the items RRP is closed we need to scroll back to top.
scrollToTop = ->
  if $('#resource-modal .shared_collection')[0]
    # When the RRP from the search page is closed we need to revert to the inital height.
    $('.shared_collection').css('height': 'auto')
  else
    window.scrollTo(0, 0)

iePreventItemDrag = ->
  if $('body').is('.ie, .edge')
    # hack to cancel a mouse drag action
    $(document).on 'mousedown', '.shared_collection .bx-viewport', ->
      $(@).on 'mousemove', ->
        $(@).off 'mousemove'
        $(@).trigger 'pointercancel'

updateSlideCounter = (index)->
  $counter = $('#item-counter')
  $counter.empty()
  $counter.append("#{index+1} of #{window.itemSlider.getSlideCount()}")

SharedCollections.adjustPanelHeight = (i) ->
  if $(".rrp-content[data-i=#{i}]").data('from-my-media')
    newHeight = $('.media-player-container').height() + 100
  else
    newHeight = $(".rrp-content[data-i=#{i}]").height()

  $('.panel-rrp .bx-viewport').height(newHeight)

SharedCollections.initEducatorRatings= ->
  `import(/* webpackChunkName: 'educator-ratings' */ 'educator_ratings')`.then((module) ->
    module.default.init()
  );

SharedCollections.bindPlayButton = ->
  $(document).on('touchstart','#play-collection-btn', ->
    $('#play-collection-btn').removeClass('force-mobile-blur')
  );

  $(document).on('touchend','#play-collection-btn', ->
    $('#play-collection-btn').addClass('force-mobile-blur')
  );

SharedCollections.bindSaveErrorsHandler = ->
  form = $('#save-collection-form')
  form.off 'ajax:error'
  form.on 'ajax:error', (e, data, status, error) ->
    rootEl = $('#limited-resources-access')[0]
    if !rootEl
      rootEl = document.createElement('div')
      rootEl.id = 'limited-resources-access'
    root = ReactDOM.createRoot(rootEl)

    handleSubmit = ->
      input = $('<input>').attr("type", "hidden").attr("name", "skip_not_accessible").val(true);
      form.append(input)
      form.submit()
      input.remove()
      root.unmount()

    props = JSON.parse(data.responseText)
    `import(/* webpackChunkName: 'limited_resource_access_modal' */ 'js/collections/limited_resource_access_modal')`.then((module) ->
      root.render(
        React.createElement(module.default, Object.assign(props, { handleSubmit }) )
      );
    )

SharedCollections.initAddToFoldersButton = (root) ->
  if LP.config.logged_in && root
    ReactDOM.createRoot(root).render(
      React.createElement(AddToFoldersButton, { url: root.getAttribute('data-url') })
    );
